import { useCallback, useEffect, useMemo, useState } from 'react';

import {
  NAV_CLICK_COUNTS_KEY,
  NAV_USAGE_UPDATED_EVENT,
  partitionNavItems,
  readNavClickCounts,
  recordNavClick,
} from '../utils/navUsage';

export function useNavUsage(visibleItems) {
  const [clickCounts, setClickCounts] = useState(() => readNavClickCounts());

  useEffect(() => {
    const sync = () => setClickCounts(readNavClickCounts());
    const onStorage = (event) => {
      if (event.key === NAV_CLICK_COUNTS_KEY) sync();
    };
    window.addEventListener(NAV_USAGE_UPDATED_EVENT, sync);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(NAV_USAGE_UPDATED_EVENT, sync);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const recordClick = useCallback((itemId) => {
    if (!itemId) return;
    setClickCounts(recordNavClick(itemId));
  }, []);

  const partitions = useMemo(
    () => partitionNavItems(visibleItems, clickCounts),
    [visibleItems, clickCounts],
  );

  return {
    clickCounts,
    recordClick,
    ...partitions,
  };
}
